module.exports = __webpack_public_path__ + "img/damuge-bai.42dfec3a.svg";